import React, { Component } from 'react';
import { withRouter } from 'react-router';

import classNames from 'classnames';
import Icon from 'components/icons';
import { I18n } from 'components/translate';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';

class ContentActionVisualize extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    onVisualize: PropTypes.func
  };

  render() {
    const { isMobile, onVisualize } = this.props;

    return (
      <button
        className="hot-button hot-button--primary hot-button--lg _mr-lg-5 _mr-2"
        disabled={!onVisualize}
        onClick={onVisualize}
      >
        <Icon
          prefix="fal"
          iconName="external-link-square-alt"
          className={classNames({ '_mr-2': !isMobile })}
        />
        {!isMobile && <I18n label="general.visualize" />}
      </button>
    );
  }
}

class ContentActionPublish extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    onPublish: PropTypes.func,
    isPublished: PropTypes.bool,
    history: PropTypes.object,
    emailNotificationBeta: PropTypes.bool
  };

  render() {
    const { onPublish, isPublished, emailNotificationBeta, history } =
      this.props;
    const isContentPage = history.location.pathname.includes('content');

    if (!isPublished && isContentPage && emailNotificationBeta) {
      return null;
    }

    const iconName = isPublished ? 'arrow-alt-to-bottom' : 'arrow-alt-to-top';
    const labelPublish = isPublished ? 'unpublish' : 'publish';

    return (
      <button
        className="hot-button hot-button--primary hot-button--lg _mt-lg-0"
        disabled={!onPublish}
        onClick={onPublish}
      >
        <Icon prefix="fal" iconName={iconName} className="_mr-2" />
        <I18n label={`general.${labelPublish}`} />
      </button>
    );
  }
}

@withRouter
@inject((stores) => ({
  emailNotificationBeta: stores.MembershipStore.emailNotificationBeta,
  isMobile: stores.UiStore.isMobile
}))
class ContentBasePageHeaderActionsDefault extends Component {
  static propTypes = {
    emailNotificationBeta: PropTypes.bool,
    history: PropTypes.object,
    isMobile: PropTypes.bool,
    onPublish: PropTypes.func,
    isPublished: PropTypes.bool,
    onVisualize: PropTypes.func
  };

  render() {
    const {
      isMobile,
      onPublish,
      isPublished,
      onVisualize,
      emailNotificationBeta,
      history
    } = this.props;

    return [
      <ContentActionVisualize
        key="first"
        onVisualize={onVisualize}
        isMobile={isMobile}
      />,
      <ContentActionPublish
        key="second"
        isPublished={isPublished}
        onPublish={onPublish}
        isMobile={isMobile}
        history={history}
        emailNotificationBeta={emailNotificationBeta}
      />
    ];
  }
}

export default class ContentBasePageHeaderActions extends Component {
  static Visualize = ContentActionVisualize;
  static Publish = ContentActionPublish;

  static Default = ContentBasePageHeaderActionsDefault;

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
  };

  render() {
    const { children, className } = this.props;

    const contentHeaderClassname = classNames(
      'content__base__page__header__actions -row',
      className
    );

    return <div className={contentHeaderClassname}>{children}</div>;
  }
}
